export default __webpack_public_path__ + "static/media/pictogramMultipleDocuments40.1f937d53.svg";